import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  const themeContext = useContext(ThemeContext);

  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66602 5H17.4993"
        stroke={themeContext.colors.font1}
        strokeOpacity="0.87"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 10H17.4993"
        stroke={themeContext.colors.font1}
        strokeOpacity="0.87"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 15H17.4993"
        stroke={themeContext.colors.font1}
        strokeOpacity="0.87"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5H2.50833"
        stroke={themeContext.colors.font1}
        strokeOpacity="0.87"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 10H2.50833"
        stroke={themeContext.colors.font1}
        strokeOpacity="0.87"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 15H2.50833"
        stroke={themeContext.colors.font1}
        strokeOpacity="0.87"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Icon;
